/**
 * État catalogue Admin après sauvegarde ProduitModal.
 *
 * Invariant : une création serveur réussie ⇒ exactement une carte,
 * et le compteur « Catalogue (N) » est juste sans refresh manuel.
 *
 * Stratégie B (retenue) : le GET liste (`serverList`) est la source unique.
 * `savedProduit` (réponse POST / GET one) ne doit PAS être concaténé ensuite.
 *
 * Le cumul historique était :
 *   await fetchProduits()          // liste serveur déjà à jour, N cartes
 *   setProduits(prev => [...prev, savedProduit])  // N+1, doublon visuel
 * Un refresh manuel ne faisait que le GET, d’où le retour à N.
 *
 * Stratégie A (append-only, non utilisée ici) : insérer savedProduit sans refetch.
 * A et B ensemble sont interdits.
 *
 * @param {{ serverList?: unknown, savedProduit?: unknown, isCreate?: boolean }} args
 * @returns {Array|null} liste à appliquer, ou null si le refetch a échoué (ne pas vider l’état)
 */
export function produitsAfterModalSave({ serverList, savedProduit, isCreate }) {
  void savedProduit;
  void isCreate;
  if (!Array.isArray(serverList)) {
    return null;
  }
  return serverList;
}
